import React from 'react';
import {URLS} from "@/lib/urls";
import {MasterLayout} from "@/components/layout/masetr/master";


function TeacherLayout({pageTitle, children, backTo}) {


    const menu = [
        {name: 'داشبورد', path: URLS.teacher.dashboard, icon: "icon-grid-2"},
        {name: 'پروفایل', path: URLS.teacher.profile.dashboard, icon: "icon-user-hair"},
        {name: 'درس‌های من', path: URLS.teacher.lessons.dashboard, icon: "icon-book-open"},
        {name: 'برنامه هفتگی', path: URLS.teacher.weekly.dashboard, icon: "icon-calendar-lines"},
        {name: 'لیست گزارش‌های عملکرد', path: URLS.teacher.reports.dashboard, icon: "icon-list-timeline"},
        {name: ' ثبت گزارش عملکرد', path: URLS.teacher.reports.create, icon: "icon-list-check"},
        {name: 'زمان های فعالیت', path: URLS.teacher.times.dashboard, icon: "icon-clock-desk"},
        {name: 'تکالیف دانش آموزان', path: URLS.teacher.homeworks.dashboard, icon: "icon-newspaper"},
    ]

    return (
        <MasterLayout module={'teacher'} pageTitle={pageTitle} sidebarMenu={menu} backTo={backTo}>
            {children}
        </MasterLayout>
    );
}

export default TeacherLayout;